import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'
import { formatDateTime, stringToDateTime } from 'utils/dateUtils'
import { NavLink } from 'react-router-dom'
import { IonIcon } from '@ionic/react'
import { listOutline, sync } from 'ionicons/icons'
import syncFilter from './syncFilter'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
}

const getRows = async (props: getRowsProps) => {
  const getParams = {}

  const response = await axiosGet(apiUrls.filters, getParams)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].action = (
      <ActionButtons
        buttons={[
          row.sync ? {
            content: (
              <NavLink
                to='#'
                title='Sync Now'
                onClick={(e) => {
                  e.preventDefault()
                  syncFilter(row.id)
                }}
              >
                <IonIcon icon={sync} className='ionicon' style={{ fontSize: '16px' }} />
              </NavLink>
            ),
          } : {},
          row.sync ? {
            content: (
              <NavLink
                to={'/filter-sync-log/' + row.id}
                title='Sync Log'
              >
                <IonIcon icon={listOutline} className='ionicon' style={{ fontSize: '16px' }} />
              </NavLink>
            ),
          } : {},
           {
            type: 'u',
            url: '/edit-filter/' + row.id,
          },
          {
            type: 'd',
            id: dataArray[index].id,
            url: '/delete-filter/' + row.id,
            setDeleteEntryId: props.setDeleteEntryId,
            setShowModal: props.setShowModal,
          },
        ]}
      />
    )

    dataArray[index].last_sync_date = dataArray[index].sync === 1 ? formatDateTime(stringToDateTime(dataArray[index].last_sync_date)) : ('-')
    dataArray[index].sync = dataArray[index].sync === 1 ? 'Yes' : 'No'
    dataArray[index].active = dataArray[index].active === 1 ? 'Yes' : 'No'
    dataArray[index].is_multi = dataArray[index].is_multi === 1 ? 'Yes' : 'No'
  })

  return data
}

export default getRows
